import { Feature, FeatureCollection, Polygon } from "geojson";

export type CalibrationItem = {
  plotId: number;
  yieldCategory: number;
  manualCount: number | null;
  color: string;
};

export type AppleFeature = Feature<
  Polygon,
  AppleCountCalibrationFeatureProperties
>;

type CoverageData = {
  count: number;
  minCount: number;
  color: string;
  bucketIndex: number;
};
export type Coverage = Record<string, CoverageData>;

export type MobileStep = "map" | "calibration";

export const MINIMUM_ITEMS = 10;

export type AppleCountCalibrationFeatureProperties = {
  apple_count: number;
  plot_id: number;
  id?: string | number;
  [other: string]: unknown;
};
export type AppleCountCalibrationFeatureCollection = FeatureCollection<
  Polygon,
  AppleCountCalibrationFeatureProperties
>;
